// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"styles_iconWrapper__WgmQx","emptyReportContent":"styles_emptyReportContent__1DrTg"};